//document.querySelector('form#customer_login_mobile').reset();
let logcurrentLanguage = document.documentElement.lang || "en";
let logintranslations = {
  en: {
    requiredFields: "Please fill in all required fields.",
    no_user_data_found: "An error occurred: No user data found.",
    invalidQatarMobile:
      "Please enter a valid Qatar mobile number.It must start with 3, 5, 6, or 7 and be 8 digits long.",
    invalidEmail: "Please enter a valid email address.",
    valid_mobile: "Please enter a valid mobile number.",
    otpSentSuccess: "OTP sent successfully!",
    otpVerificationFailed: "OTP verification failed.",
    otpRequired: "Please enter the OTP.",
    recovery_email_sent:
      "A recovery email has been sent to your address. Please check your inbox.",
    emailSentReset:
      "We have sent an email to reset your password. Please check your inbox.",
    noRegistrationData: "An error occurred: No registration data found.",
    otpError: "An error occurred while sending the OTP.",
    login_error: "An error occurred during login.",
    login_failed: "Login failed.",
    login_success: "Login successful!",
    enter_email: "Please enter your email.",
    enter_phone: "Please enter your phone number.",
    request_processed: "Request processed.",
    general_error: "An error occurred. Please try again.",
    recovery_error:
      "Recovery request failed. Please check the email address and try again.",
    too_many_attempts:
      "Recovery failed. Too many attempts error page received.",
    otpVerificationError: "An error occurred during OTP verification.",
    account_recovery_error:
      "An error occurred during account recovery. Please try again later.",
    incorrectEmailorPassword: "Incorrect email or password",
    unexpected_error: "An unexpected error occurred. Please try again",
    incorrectPassword: "Incorrect Password",
    minCharacterPassword: "Password must be at least 5 characters long.",
  },
  ar: {
    requiredFields: "يرجى ملء جميع الحقول المطلوبة",
    no_user_data_found: "حدث خطأ: لم يتم العثور على بيانات المستخدم.",
    invalidQatarMobile:
      "قم الجوال غير صالح. يجب أن يبدأ بـ 3 أو 5 أو 6 أو 7 وأن يتكون من 8 أرقام يرجى إدخال رقم هاتف قطري صحي",
    invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح.",
    valid_mobile: "يرجى إدخال رقم موبايل صالح.",
    otpSentSuccess: "تم إرسال رمز OTP بنجاح!",
    otpVerificationFailed: "فشل التحقق من رمز OTP.",
    otpRequired: "يرجى إدخال رمز OTP.",
    recovery_email_sent:
      "تم إرسال بريد إلكتروني للاسترداد إلى عنوانك. يرجى التحقق من صندوق الوارد.",
    customerExistsLocal:
      "العميل موجود بالفعل. جارٍ إعادة التوجيه لتسجيل الدخول...",
    customerExistsERP:
      "العميل موجود في النظام. جارٍ إعادة التوجيه لإعادة تعيين كلمة المرور...",
    emailSentReset:
      "لقد أرسلنا بريدًا إلكترونيًا لإعادة تعيين كلمة المرور. يرجى التحقق من بريدك الوارد.",
    noRegistrationData: "حدث خطأ: لم يتم العثور على بيانات التسجيل.",
    otpError: "حدث خطأ أثناء إرسال رمز OTP.",
    login_error: "حدث خطأ أثناء تسجيل الدخول.",
    login_failed: "فشل تسجيل الدخول.",
    login_success: "تم تسجيل الدخول بنجاح!",
    enter_email: "يرجى إدخال بريدك الإلكتروني.",
    enter_phone: "يرجى إدخال رقم هاتفك.",
    request_processed: "تم معالجة الطلب.",
    general_error: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    recovery_error:
      "فشل طلب الاستعادة. يرجى التحقق من عنوان البريد الإلكتروني والمحاولة مرة أخرى.",
    too_many_attempts: "فشل الاستعادة. تم تلقي خطأ بسبب العديد من المحاولات.",
    otpVerificationError: "حدث خطأ أثناء التحقق من OTP.",
    account_recovery_error:
      "حدث خطأ أثناء استرداد الحساب. يرجى المحاولة لاحقًا.",
    incorrectEmailorPassword: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    unexpected_error: "حدث خطأ غير متوقع. الرجاء المحاولة مرة أخرى",
    incorrectPassword: "كلمة المرور غير صحيحة.",
    minCharacterPassword: "يجب أن تكون كلمة المرور مكونة من 5 أحرف على الأقل.",
  },
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onPageLoad);
} else {
  onPageLoad();
}

function onPageLoad() {
  const showError = (messageKey, divId, type = "error") => {
    // Language selector (default: English)
    const message =
      logintranslations[logcurrentLanguage]?.[messageKey] ||
      messageKey ||
      "An unknown error occurred.";

    const pwdDiv = document.querySelector("p.pwdmsg");
    const errorDiv = document.getElementById(divId);

    // Handle missing errorDiv gracefully
    if (!errorDiv) {
      console.error(`No element found with id: ${divId}`);
      return;
    }

    if (type === "otp") {
      const otpError = document.getElementById("otp-error"); // Ensure otpError is defined
      if (!otpError) {
        console.error("No OTP error element found");
        return;
      }
      otpError.style.display = "block";
      otpError.innerText = message;
      otpError.style.color = type === "success" ? "green" : "red"; // Set message color
      otpError.setAttribute("tabindex", "-1"); // Make it focusable
      otpError.focus();
      otpError.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      if (pwdDiv) {
        pwdDiv.style.display = "none";
      }
      errorDiv.style.display = "block";
      errorDiv.innerText = message;
      errorDiv.style.color = type === "success" ? "green" : "red"; // Set message color
      errorDiv.setAttribute("tabindex", "-1"); // Make it focusable
      errorDiv.focus();
      errorDiv.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const handleLoginError = (message, type) => {
    
    const errorDivMap = {
      mobile: "mobile-login-error",
      email: "email-login-error",
      reset_email: "reset_email",
      reset_phone: "reset_phone",
      otp: "otp-error",
      forgot_otp: "forgotpassword-otp-error",
    };
    loginButton.classList.remove("progressing");
    document.getElementById("customer-login-button").classList.remove('progressing');
    const errorDivId = errorDivMap[type];
    
    if (!errorDivId) {
     // console.error(`Invalid error type: ${type}`);
      return;
    }

    showError(message, errorDivId);
  };
  // Function to validate required fields dynamically
  function validateRequiredFields(fields) {
    let isValid = true;
    fields.forEach((field) => {
      // Check if the field is empty
      if (!field.value.trim()) {
        isValid = false;
        field.classList.add("error"); // Highlight the invalid field
      } else {
        field.classList.remove("error"); // Remove error highlight if valid
      }
    });

    return isValid;
  }

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  //////////////////// LOGIN BY EMAIL ////////////////////////////
  // Select the login button

  const loginButton = document.getElementById("login-email-button");

  // Add click event listener to the login button
    loginButton.addEventListener("click", async (e) => {
     
    e.preventDefault(); // Prevent the form from submitting normally
     loginButton.classList.add("progressing");
    // Clear any existing errors before processing
    utils.clearError("email-login-error");

    const requiredFields = [
      document.querySelector("#customer_login #CustomerEmail"),
      document.querySelector("#customer_login #CustomerPassword"),
    ];

    // Validate required fields
    if (!validateRequiredFields(requiredFields)) {
      handleLoginError("requiredFields", "email");
      loginButton.classList.remove("progressing");
      return;
    }

    const email = document.querySelector(
      "#customer_login #CustomerEmail"
    ).value;
    const password = document.querySelector("#customer_login #CustomerPassword")
      ? document.querySelector("#customer_login #CustomerPassword").value
      : "";

    // Validate email address
    if (!isValidEmail(email)) {
      handleLoginError("invalidEmail", "email");
      loginButton.classList.remove("progressing");
      return;
    }

    try {
      const response = await loginUserShopify(email, password, "email");
      //console.log("Response:", response);
    } catch (error) {
       loginButton.classList.remove("progressing");
     // console.error("Error:", error);
    }
  });

  async function loginUserShopify(email, password, type) {
    
    // Form data
    const formData = new URLSearchParams({
      form_type: "customer_login",
      "customer[email]": email,
      "customer[password]": password,
    });
    ///console.log(formData);
   // return false;
    try {
      // Send AJAX request to Shopify login endpoint
      const response = await fetch("/account/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      if (response.ok) {
        
        const data = await response;
        // Check if login was successful by inspecting the response
        if (data.url.includes("/account/login")) {
         
          // Handle error (e.g., wrong credentials)
          if (type == "email")
            handleLoginError("incorrectEmailorPassword", type);
          else handleLoginError("incorrectPassword", type);
        } else {
          // Redirect or handle post-login actions
          const redirectUrl =
            logcurrentLanguage === "ar" ? "/ar/account" : "/account";
           //check if customer 
          //if customer come from checkout page
          if(localStorage.getItem("offerCheckout")=="1"){
            startCheckoutProcess(email);  //function defined in bogo-offer-rules.js
          }else{
          //end code
            //if check if user coming from checkout page
            const params = new URLSearchParams(window.location.search);
            
            const checkoutParam = params.get('checkout_url');
           if (checkoutParam) {
            // Decode it (it comes in encoded form, e.g. "%2Fcheckouts%2F…")
             const checkoutredirectUrl = decodeURIComponent(checkoutParam);
             
            // alert(checkoutredirectUrl);
              //window.location.replace(checkoutredirectUrl);
               window.location.href = checkoutredirectUrl;
            }else{
             window.location.replace(redirectUrl);
            }
            //end
            // alert(redirectUrl);
            //alert('I am here');
              //window.location.replace(redirectUrl);
          }
          // window.location.href = redirectUrl;
        }
      } else {
         loginButton.classList.remove("progressing");
        throw new Error("Login failed");
      }
    } catch (error) {
       loginButton.classList.remove("progressing");
     // console.log("Error during AJAX login:", error);
     // return false;
      handleLoginError("An error occurred. Please try again later.", type);
    }
  }

  // Add input listeners to clear errors when the user starts typing
  document
    .getElementById("CustomerEmail")
    .addEventListener("input", () => utils.clearError("email-login-error"));
  document
    .querySelector("#customer_login #CustomerPassword")
    .addEventListener("input", () => utils.clearError("email-login-error"));
  document
    .getElementById("login-phone-number")
    .addEventListener("input", () => utils.clearError("mobile-login-error"));
  document
    .querySelector("#customer_login_mobile #CustomerPassword")
    .addEventListener("input", () => utils.clearError("mobile-login-error"));
  document
    .getElementById("RecoverEmail")
    .addEventListener("input", () => utils.clearError("reset_email"));
  document
    .getElementById("RegisterForm-number")
    .addEventListener("input", () => utils.clearError("reset_phone"));

  //////////////////// LOGIN BY PHONE ////////////////////////////

  const sendOtpButton = document.getElementById("send-otp");
  const otpSection = document.getElementById("otp-section");
  const otpInput = document.getElementById("otp-input");
  const otpError = document.getElementById("otp-error");
  const otpUserMob = document.querySelector(".user-details");
  const loginFieldsDiv = document.querySelector(".login-fields");
  const showOtpSection = () => {
    //sendOtpButton.style.display = "block";
    loginFieldsDiv.style.display = "none";
    otpSection.style.display = "block";
    otpUserMob.innerText = document
      .getElementById("login-phone-number")
      .value.trim();
    otpInput.focus(); // Focus on the OTP input for better UX
  };

  const hideOtpSection = () => {
    sendOtpButton.style.display = "none";
    otpSection.style.display = "none";
    otpInput.value = ""; // Clear the OTP input
  };
  // Validate OTP Input and Move Cursor to Next Box
  function validateAndMove(input, nextId) {
    if (!/^\d$/.test(input.value)) {
      input.value = ""; // Clear invalid input
      return;
    }
    if (nextId) {
      document.getElementById(nextId).focus();
    }
  }
  function startTimer() {
    let countdownTime = 300; // Timer in seconds
    const timerElement = document.getElementById("timerText");
    const resendButton = document.getElementById("resendButton");
    const timerDiv = document.getElementById("timer");

    // Reset display
    timerDiv.style.display = "block";
    resendButton.style.display = "none";
    timerElement.textContent = `Resend OTP in: ${countdownTime} seconds`;

    const interval = setInterval(() => {
      countdownTime--;

      // Update the timer text
      timerElement.textContent = `Resend OTP in: ${countdownTime} seconds`;

      // When the countdown ends
      if (countdownTime <= 0) {
        clearInterval(interval);
        timerDiv.style.display = "none";
        resendButton.style.display = "block"; // Show the Resend OTP button
      }
    }, 800);
  }

  async function sendOrResendOTP(action) {
    try {
      // Retrieve the form data from localStorage
      const storedData = localStorage.getItem("logindata");
      const formData = storedData ? JSON.parse(storedData) : null;

      if (!formData) {
        showError("no_user_data_found", "mobile-login-error");
        return;
      }

      const response = await sendRequest(action, formData);

      if (response.ok && response.data.status === "otp_sent") {
        utils.clearError("mobile-login-error");

        showError("otpSentSuccess", "mobile-login-error", "success");
        showOtpSection();
        startTimer();
        setupOtpVerification(formData);
      } else {
        showError(
          response.data.message || "Failed to send OTP.",
          "mobile-login-error"
        );
      }
    } catch (error) {
     // console.error(`Error during ${action} OTP:`, error);
      showError("otpError", "mobile-login-error");
    }
  }

  document.getElementById("resendButton").addEventListener("click", () => {
    sendOrResendOTP("resend_otp");
  });
  // Validate phone number format (for Qatar)
  const isValidQatarMobile = (phoneNumber) => {
    // Check if the number starts with +974 and is valid
    if (/^\+974[3567][0-9]{7}$/.test(phoneNumber)) {
      // Remove the +974 prefix and return the 8-digit number
      phoneNumber = phoneNumber.replace(/^\+974/, "");
    }

    // If no +974 prefix, validate as an 8-digit number
    if (/^[3567][0-9]{7}$/.test(phoneNumber)) {
      return phoneNumber; // Return the 8-digit number as it is valid
    }

    // If neither condition is met, return false
    return false; // Invalid number
  };
  document.querySelector("#customer_login_mobile #login-phone-number").addEventListener("input", function (e) {
  // Remove spaces from input value
  this.value = this.value.replace(/\s+/g, "");
});
  document
    .getElementById("customer-login-button")
    .addEventListener("click", async (e) => {
         document.getElementById("customer-login-button").classList.add('progressing');
      e.preventDefault();
      const phoneNumber = document
        .querySelector("#customer_login_mobile #login-phone-number")
        .value.trim();
      const password = document
        .querySelector("#customer_login_mobile #CustomerPassword")
        .value.trim();
      const frmdata = { mobile: phoneNumber, password: password };

      // Validate required fields
      const loginRequiredFields = [
        document.querySelector("#customer_login_mobile #login-phone-number"),
        document.querySelector("#customer_login_mobile #CustomerPassword"),
      ];

      if (!validateRequiredFields(loginRequiredFields)) {
        handleLoginError("requiredFields", "mobile");
        return;
      }

      if (!isValidQatarMobile(phoneNumber)) {
        handleLoginError("invalidQatarMobile", "mobile");
        return;
      }

      try {
        const response = await sendRequest("login_phone", {
          phone: phoneNumber,
          password: password,
        });

        if (response.ok && response.data.status === "otp_sent") {
          utils.clearError("mobile-login-error");
          localStorage.setItem("logindata", JSON.stringify(frmdata));
          showOtpSection();
          startTimer();
          setupOtpVerification(frmdata);
        }else if(response.ok && response.data.status === "login_with_phone_ok") { //new code by pj to avoid OTP for login with mobile number if customer state enabled
          email =  response.data.message;
          
          try {
          const response = await loginUserShopify(email, password, "email");
          //console.log("Response:", response);
        } catch (error) {
           loginButton.classList.remove("progressing");
         // console.error("Error:", error);
        }
  
          ///end new code
        } else {
          handleLoginError(response.data.message || "login_failed", "mobile");
        }
      } catch (error) {
        //console.error("Error during login:", error);
        // handleLoginError('login_error', 'mobile');
      }
    });

  const setupOtpVerification = (formData) => {
    sendOtpButton.addEventListener("click", async () => {
      sendOtpButton.classList.add("loading"); // Add loading class

      // const pageDiv = document.querySelector(".login-page"); // Ensure correct selector (use '.' for class)
      // if (pageDiv) {
      //   pageDiv.classList.add("login_processing");
      // }
      // Collect OTP from the input boxes
      let otpValue = "";
      for (let i = 1; i <= 6; i++) {
        otpValue += document.getElementById("otp" + i).value;
      }
      otpInput.value = otpValue;
      const otp = otpInput.value.trim();
      if (!otp) {
        otpError.innerText = "Please enter the OTP.";
        otpInput.focus();
        sendOtpButton.classList.remove("loading"); // Remove loading class if validation fails
        return;
      }
      otpError.innerText = "";
      await verifyOtp(otp, formData);
      sendOtpButton.classList.remove("loading"); // Remove loading class after request completes
    });
  };

  //OTP verification
  async function verifyOtp(otp, frmdata) {
    try {
      const response = await sendRequest("verify_otp", {
        data: frmdata,
        otp,
        verify_type: "login_phone",
      });

      if (response.ok && response.data.status === "success") {
        const pageDiv = document.querySelector(".login-page"); // Ensure correct selector (use '.' for class)
        if (pageDiv) {
          pageDiv.classList.add("login_processing");
        }

        const { email, password } = response.data.meta || {};
        if (email && password) {
          //handleLoginError("login_success", "mobile");
          setTimeout(async () => {
            try {
              const response = await loginUserShopify(
                email,
                password,
                "mobile"
              );
             // console.log("Response:", response);
            } catch (error) {
             // console.error("Error:", error);
            }
          }, 500);
        } else {
          throw new Error(
            "Invalid response: Email or password missing in meta data."
          );
        }
      } else {
        handleLoginError(
          response.data.message || "otpVerificationFailed",
          "otp"
        );
      }
    } catch (error) {
     // console.error("Error during OTP verification:", error);
      handleLoginError("otpVerificationError", "mobile");
    }
  }

  ////////////////////////RESET PASSWORD //////////////////////////////////
  const recoverPassword = async (email, errorDivId) => {
    try {
      const recoverButton = document.getElementById("customer-login-button"); // Ensure the button has this ID
      if (recoverButton) {
        recoverButton.classList.add("loading"); // Add loading class
      }

      // Validate email format
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        throw new Error("Invalid email format");
      }

      const formData = new URLSearchParams({
        form_type: "customer_recover", // This is fine for password recovery
        "customer[email]": email.trim(),
      });

      try {
        // Send AJAX request to Shopify password recovery endpoint
        const response = await fetch("/account/recover", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData.toString(),
        });

        // Check if the response is successful
        if (!response.ok) {
          //console.error("Password recovery failed with status:", response.status);
          const errorData = await response.text(); // Or .json() if the server sends JSON
          showError("Password recovery failed.", errorDivId, "error");
        } else if (response.ok) {
          // If successful, process the data
          const data = await response.text(); // Or .json() depending on the server's response
          // console.log("Password recovery request successful:", data);
          showError("Recovery email sent successfully.", errorDivId, "success");
          if (recoverButton) {
            recoverButton.classList.remove("loading"); // Remove loading class after request completes
          }
        }
      } catch (error) {
        //console.error("Request failed:", error);
      }
    } catch (error) {
      //console.error("Request failed:", error);
    }
  };

  //Case 2:
  ////////////////////////FORGOT PASSWORD ////////////////////////////////
  const sendForgotPasswordOtpButton = document.getElementById(
    "forgotpassword-send-otp"
  );
  const forgotPasswordOtpSection = document.getElementById(
    "forgotpassword-otp-section"
  );
  const forgotPasswordOtpInput = document.getElementById(
    "forgotpassword-otp-input"
  );
  const forgotPasswordOtpError = document.getElementById(
    "forgotpassword-otp-error"
  );
  const forgotPasswordUserMob = document.querySelector(
    "#forgotpassword-otp-section .user-details"
  );
  const forgotPasswordFieldsDiv = document.querySelector(".forgot_fields");
  const forgotPasswordResendButton = document.getElementById(
    "forgotpassword-resendButton"
  );
  const forgotPasswordTimer = document.getElementById("forgotpassword-timer");
  const forgotPasswordTimerText = document.getElementById(
    "forgotpassword-timerText"
  );

  // Show OTP Section for Forgot Password
  const showForgotPasswordOtpSection = () => {
    forgotPasswordFieldsDiv.style.display = "none";
    forgotPasswordOtpSection.style.display = "block";
    forgotPasswordUserMob.innerText = document
      .getElementById("RegisterForm-number")
      .value.trim();
    forgotPasswordOtpInput.focus(); // Focus on OTP input for better UX
  };

  // Hide OTP Section for Forgot Password
  const hideForgotPasswordOtpSection = () => {
    forgotPasswordOtpSection.style.display = "none";
    forgotPasswordOtpInput.value = ""; // Clear the OTP input
  };

  // Start Timer for Resend OTP in Forgot Password Flow
  function startForgotPasswordTimer() {
    let countdownTime = 300; // Timer in seconds

    // Reset display
    forgotPasswordTimer.style.display = "block";
    forgotPasswordResendButton.style.display = "none";
    forgotPasswordTimerText.textContent = `Resend OTP in: ${countdownTime} seconds`;

    const interval = setInterval(() => {
      countdownTime--;
      forgotPasswordTimerText.textContent = `Resend OTP in: ${countdownTime} seconds`;

      if (countdownTime <= 0) {
        clearInterval(interval);
        forgotPasswordTimer.style.display = "none";
        forgotPasswordResendButton.style.display = "block"; // Show Resend OTP button
      }
    }, 1000);
  }

  // Send or Resend OTP for Forgot Password
  async function sendOrResendForgotPasswordOTP(action) {
    const button = forgotPasswordResendButton;
    button.classList.add("loading"); // Add loading class
    try {
      const mobileNumber = document
        .getElementById("RegisterForm-number")
        .value.trim();
      localStorage.setItem("mobile", mobileNumber);
      if (!mobileNumber) {
        showError("Please enter your registered mobile number.", "reset_phone");
        return;
      }

      const requestData = {
        mobile: mobileNumber,
        action: action,
        mode: "forgot_pwd",
      };

      const response = await sendRequest(action, requestData);

      if (response.ok && response.data.status === "otp_sent") {
        showError("OTP sent successfully!", "reset_phone", "success");
        showForgotPasswordOtpSection();
        startForgotPasswordTimer();
        setupForgotPwdOtpVerification({ mobile: mobileNumber });
      } else {
        showError(
          response.data.message || "Failed to send OTP.",
          "reset_phone"
        );
      }
    } catch (error) {
      //console.error(`Error during ${action} OTP:`, error);
      showError("An error occurred while sending OTP.", "reset_phone");
    }
    // finally {
    // button.classList.remove("loading"); // Remove loading class
    // }
  }

  // Event Listener for Resend OTP Button
  forgotPasswordResendButton.addEventListener("click", () => {
    sendOrResendForgotPasswordOTP("resend_otp");
  });

  // Event Listener for Send OTP Button
  //sendForgotPasswordOtpButton.addEventListener("click", () => {
  //   sendOrResendForgotPasswordOTP("send");
  // });

  const setupForgotPwdOtpVerification = (formData) => {
    sendForgotPasswordOtpButton.addEventListener("click", async () => {
      document.getElementById("forgotpassword-send-otp").style.display =
        "block";

      // Collect OTP from the input boxes
      let otpValue = "";
      for (let i = 1; i <= 6; i++) {
        otpValue += document.getElementById("forgotpassword-otp" + i).value;
      }
      otpInput.value = otpValue;
      const otp = otpInput.value.trim();
      if (!otp) {
        otpError.innerText = "Please enter the OTP.";
        otpInput.focus();
        return;
      }
      otpError.innerText = "";
      await verifyForgotPwdOtp(otp, formData);
    });
  };
  //OTP verification
  async function verifyForgotPwdOtp(otp, frmdata) {
    try {
      const response = await sendRequest("verify_otp", {
        data: frmdata,
        otp,
        verify_type: "forgot_pwd",
      });

      if (response.ok && response.data.status === "success") {
        document.getElementById("reset-password-form").style.display = "none";
        document.getElementById("email-reset-form").style.display = "none";
        if (response.data.message === "send_email") {
          //showError("Password reset email sent successfully!", "reset_phone");
          showPasswordResetSection(); // Show input fields for new password
        } else if (response.data.message === "update_send_email") {
          showEmailInputField(); // Show email input field only when update is required
        }
      } else {
        handleLoginError(
          response.data.message || "otpVerificationFailed",
          "forgot_otp"
        );
      }
    } catch (error) {
     // console.error("Error during OTP verification:", error);
      handleLoginError("otpVerificationError", "mobile");
    }
  }
   /////////////////////////Forgot pwd with email updation/////////////////////////
function startOTPTimer(timerId, resendButtonId) {
    const timerElement = document.getElementById(timerId);
    const resendButton = document.getElementById(resendButtonId);
    if (!timerElement || !resendButton) {
      // console.error(
      //   `Error: Missing elements. Timer ID: ${timerId}, Resend Button ID: ${resendButtonId}`
      // );
      return;
    }

    const timerDiv = timerElement.parentElement;
    
    if (!timerDiv) {
     // console.error(`Error: Timer element (${timerId}) has no parent.`);
      return;
    }
    let countdownTime = 300; // Timer in seconds
    // Show Timer and Hide Resend Button
 
    timerDiv.style.display= "block";
    resendButton.style.display="none";
    // Set Initial Timer Text
     timerElement.textContent = `Resend OTP in: ${countdownTime} seconds`;
     const interval = setInterval(() => {
      countdownTime--;

      // Update the timer text
      timerElement.textContent = `Resend OTP in: ${countdownTime} seconds`;

      // When the countdown ends
      if (countdownTime <= 0) {
        clearInterval(interval);
        timerDiv.style.display= "none";
        resendButton.style.display= "block";
      }
    }, 800);
  }


  async function showEmailInputField() {
  const mobnum    = document.querySelector('#RegisterForm-number').value;
  const container = document.getElementById("reset_email_field_1");
  container.classList.remove("hidden");

  if (!container) {
   // console.error("Container #reset_email_field_1 not found!");
    return;
  }

  // Clear existing elements
  container.innerHTML = "";

  // Hide OTP Section if already visible
  const otpSection = document.getElementById("email-otp-section");
  if (otpSection) {
    otpSection.style.display = "none";
  }
  // Create label element
  const emailLabel = document.createElement("label");
  emailLabel.classList.add("field__label-right");
  emailLabel.setAttribute("for", "emailInput");
  emailLabel.textContent = "Please enter a valid email";

  // Create Email Input
  const emailInput = document.createElement("input");
  emailInput.type = "email";
  emailInput.id = "emailInput";
  emailInput.classList.add("form-control");
  emailInput.placeholder = "Please enter your valid email";

  // Create Send OTP Button
  const sendOtpBtn = document.createElement("button");
  sendOtpBtn.id = "sendEmailOtpBtn";
  sendOtpBtn.classList.add("submit-btn");
  sendOtpBtn.textContent = "Send OTP";

  // Append Email Input and Send OTP Button
  container.appendChild(emailLabel);
  container.appendChild(emailInput);
  container.appendChild(sendOtpBtn);
 // Add Input Event Listener for Validation
    emailInput.addEventListener("input", () => {
    const email = emailInput.value.trim();
    const errorMessage = document.getElementById("email-reset-status-msg");

    if (errorMessage) utils.clearError("email-reset-status-msg");
    
  });

  sendOtpBtn.addEventListener("click", async () => {

    const email = emailInput.value.trim();
    sendOtpBtn.classList.add("loading"); // Show loading effect

    if (!isValidEmail(email)) {
      showError("Invalid email format.", "email-reset-status-msg", "error");
      sendOtpBtn.classList.remove("loading");
      return;
    }

    try {
    const response = await sendRequest("send_email_otp", { email:email,mobile:mobnum });
      document.getElementById("email-reset-form").style.display = "block";
      if (response.ok && response.data.status === "otp_sent") {
       document.getElementById("email-reset-status-msg").textContent="";
       document.querySelector('.user-email-details').innerHTML=email;
       localStorage.setItem("emaildata", JSON.stringify({email:email,mobile:mobnum}));


        document.getElementById("reset_email_field_1").style.display = "none";
       // showError("OTP sent to your email.", "email-reset-status-msg", "success");

        // Show the OTP Section
        otpSection.style.display = "block";

        // Start the OTP timer
        startOTPTimer("email-timerText", "email-resendButton");
         // Set up OTP verification
          setupEmailOtpVerification();
      } else {
        showError(response.data.message || "Failed to send OTP.", "email-reset-status-msg", "error");
      }
    } catch (error) {
     // console.error("Error sending email OTP:", error);
    } finally {
      sendOtpBtn.classList.remove("loading"); // Remove loading effect
    }
  });
}

  const sendEmailOtpButton = document.getElementById("sendEmailOtpBtn");
  const emailResendButton = document.getElementById("email-resendButton");

  const setupEmailOtpVerification = () => {
    document
      .getElementById("verifyEmailOtpBtn")
      ?.addEventListener("click", async () => {

        let otpValue = "";
        for (let i = 1; i <= 6; i++) {
          const inputBox = document.getElementById("email-otp" + i);
          if (inputBox) {
            otpValue += inputBox.value.trim();
          }
        }

        if (!otpValue || otpValue.length !== 6) {
          showError(
            "Please enter a valid 6-digit OTP.",
            "email-reset-status-msg",
            "error"
          );
          return;
        }

        try {
          const email = document.getElementById("emailInput").value.trim();
          const response = await sendRequest("verify_email_otp", {
            email,
            otp: otpValue,
          });

          if (response.ok && response.data.status === "verified") {
            showError(
              "OTP Verified! Updating email...",
              "email-reset-status-msg",
              "success"
            );
            await updateEmail(email);
          } else {
            showError(
              response.data.message || "OTP verification failed.",
              "email-reset-status-msg",
              "error"
            );
          }
        } catch (error) {
         // console.error("Error verifying OTP:", error);
        }
      });
  };

  //Function to update email after OTP verification
  async function updateEmail(email) {
    try {
      const requestData = {
        mobile: document.getElementById("RegisterForm-number").value.trim(),
        email,
        action: "update_email_and_send_password",
      };

      const responses = await sendRequest(
        "update_email_and_send_password",
        requestData
      );

      if (responses.ok && responses.data.status === "success") {
        showError("Email updated successfully.", "email-reset-status-msg", "success");
        const emailpwd = document.getElementById(
          "reset_email_password_field_1"
        );
        if (emailpwd) emailpwd.style.display = "block";

        //Need to show password change option
        await showPasswordResetSection();
        // Optionally, redirect the user or log them in automatically
      } else {
        showError(
          response.data.message || "Failed to update email.",
          "email-reset-status-msg",
          "error"
        );
      }
    } catch (error) {
      //console.error("Error updating email:", error);
    }
  }
  async function sendOrResendEmailOTP(action) {
    try {
        // Retrieve user data from localStorage
        const storedData = localStorage.getItem("emaildata");
        const formData = storedData ? JSON.parse(storedData) : null;

        if (!formData || !formData.email) {
            showError("No user data found.", "email-reset-status-msg");
            return;
        }

        const response = await sendRequest(action, formData);

        if (response.ok && response.data.status === "otp_sent") {
          //  showError("OTP sent successfully!", "email-reset-status-msg");
            document.getElementById("email-otp-section").style.display= "block";
            startOTPTimer("email-timerText", "email-resendButton");
            // Set up OTP verification
            setupEmailOtpVerification();
        } else {
            showError(response.data.message || "Failed to send OTP.", "email-reset-status-msg");
        }
    } catch (error) {
       // console.error(`Error during ${action} OTP:`, error);
        showError("An error occurred. Please try again.", "email-reset-status-msg");
    }
}
  // Event listener for Resend OTP button
document.getElementById("email-resendButton").addEventListener("click", () => {
    sendOrResendEmailOTP("resend_email_otp");
});
/////////////////////OTP EMAIL End////////////////////////////
  // Function to show password reset fields
  async function showPasswordResetSection() {

    const container = document.getElementById("reset_email_password_field_1"); // Correct container ID
    if (!container) {
     // console.error("Container #reset_email_password_field_1 not found!");
      return;
    }
    container.style.display = "block";
    // Prevent duplicate sections
    if (document.getElementById("password-reset-section")) return;

    // Create password reset section
    let passwordResetDiv = document.createElement("div");
    passwordResetDiv.id = "password-reset-section";
    passwordResetDiv.innerHTML = `
        <h3>Update Your Password</h3>
        <div class="field">
          <label for="new-password" class="field__label-right"> Enter new password</label>
          <input type="password" id="new-password">
        </div>
        <div class="field">
         <label for="confirm-password" class="field__label-right"> Confirm new password</label>
        <input type="password" id="confirm-password">
        </div>
        <button type="button" id="update-password-btn">Update Password</button>`;

    // Hide OTP section if it exists
    const otpSection = document.getElementById("email-otp-section");
    if (otpSection) otpSection.style.display = "none";

    // Append elements
    container.appendChild(passwordResetDiv);
    const otpsSection = document.getElementById("reset_email_otp_field_1");
    if (otpsSection) otpsSection.style.display = "none";

    // Add event listener for password update
    document
      .getElementById("update-password-btn")
      .addEventListener("click", async () => {
        const updateButton = document.getElementById("update-password-btn");
        updateButton.classList.add("loading"); // Add loading class
        const newPassword = document
          .getElementById("new-password")
          .value.trim();
        const confirmPassword = document
          .getElementById("confirm-password")
          .value.trim();
        if (!newPassword || newPassword.length < 5) {
         // console.error("Password must be at least 5 characters long.");
          showError("minCharacterPassword", "reset_phone", "error");
          return false; // Validation failed
        }
        if (newPassword !== confirmPassword) {
          showError("Passwords do not match.", "reset_phone", "error");
          updateButton.classList.remove("loading"); // Remove loading class
          return;
        }

        const requestData = {
          mobile: document.getElementById("RegisterForm-number").value.trim(),
          password: newPassword,
          action: "updatepwd",
        };

        try {
          const response = await sendRequest("updatepwd", requestData);

          if (response.ok && response.data.status === "success") {
            showError(
              "Password updated successfully.",
              "reset_phone",
              "success"
            );
            window.location.replace("/account/login");
          } else {
            showError(
              response.data.message || "Failed to update password.",
              "reset_phone",
              "success"
            );
          }
        } catch (error) {
        //  console.error("Error updating password:", error);
        } finally {
          updateButton.classList.remove("loading"); // Remove loading class
        }
      });
  }
  // Reset Password Click by Mobile Number

  document
    .getElementById("reset-password-button")
    .addEventListener("click", async function () {
      const resetButton = document.getElementById("reset-password-button");
      resetButton.classList.add("loading");
      utils.clearError("forgot_fields");
      const phoneNumber = document
        .getElementById("RegisterForm-number")
        .value.trim();

      if (!phoneNumber) {
        
        showError("enter_phone", "reset_phone");
        return;
      }
      if (!isValidQatarMobile(phoneNumber)) {
        
        showError("invalidQatarMobile", "reset_phone");
        return;
      }

      try {
        const response = await sendRequest("forgot_password", {
          mobile: phoneNumber,
        });

        if (response.ok && response.data.status === "otp_sent") {
          utils.clearError("reset_phone");
          localStorage.setItem("mobilenum", phoneNumber);
          showForgotPasswordOtpSection();
          startForgotPasswordTimer();
          setupForgotPwdOtpVerification({ mobile: phoneNumber });
        } else {
          showError(
            response.data.message || "request_processed",
            "reset_phone"
          );
        }
      } catch (error) {
      //  console.error("Error during sending password:", error);
        showError("otpError", "reset_phone");
        
      }
      //   finally {
      //     resetButton.classList.remove("loading");
      // }
    });

  //// Common Function

  async function sendRequest(action, data) {
    const response = await fetch(
      "https://app.wellcareonline.com/api/customer/post",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action, ...data }),
        redirect: "manual",
      }
    );
    const result = await response.json();
    return { ok: response.ok, data: result };
  }
}
